var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.995,
    height: 32,
    viewBox: "0 0 31.995 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#407fff;}.b{fill:#406aef;}.c{fill:#ccf4ff;}.d{fill:#48d8ff;}.e{fill:#43c5ff;}.f{fill:#e3faff;}.g{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.368)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.368)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.995,16A16,16,0,1,0,16,32,16,16,0,0,0,31.995,16Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.912,39.8a16,16,0,0,1-19.877,24.83A16,16,0,1,0,94.912,39.8Zm0,0",
    transform: "translate(-70.346 -37.313)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M306.42,155.289l-1.089,1.089,1.3,1.3-4.279,4.279-.59-.59-1.876,1.876L301,164.358l7.244-7.244Z",
    transform: "translate(-281.144 -145.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M102.544,376.168l-.974-.974s-1.061.974-.853,1.827C101.57,377.23,102.544,376.168,102.544,376.168Z",
    transform: "translate(-94.396 -351.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M102.894,383.535c-.226.225-1.04.969-1.766.791l1.34-1.34.487.487S102.933,383.5,102.894,383.535Z",
    transform: "translate(-94.808 -359.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M112.037,292.863l-.259.259-2.337,4.676,1.518,1.518,4.676-2.337.259-.259Z",
    transform: "translate(-102.601 -274.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M127.278,325.646l-.259.259-4.677,2.337-.759-.759,3.766-3.766Z",
    transform: "translate(-113.985 -303.485)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 5.455,
    height: 18.171,
    transform: "translate(13.034 22.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 18.171,
    height: 2.727,
    transform: "translate(25.883 9.571) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 5.455,
    height: 1.54,
    transform: "translate(18.295 17.159) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.54,
    height: 2.727,
    transform: "translate(19.384 16.071) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 5.455,
    height: 1.794,
    transform: "translate(25.833 9.621) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.794,
    height: 2.727,
    transform: "translate(27.102 8.353) rotate(135)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.7b535acc8e3f54d74243ac674bd67b44.svg";
export { ForwardRef as ReactComponent };